import React from 'react';

const unsubscribeConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				}, 
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: '/unsubscribe',
			component: React.lazy(() => import('./unsubscribe'))
		},
	]
};

export default unsubscribeConfig;